/**
 * Google Analytics Gtag Setting
 */

export default defineNuxtPlugin(() => {
  const router = useRouter();
  const { $i18n } = useNuxtApp();
  const { locale } = $i18n;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function <T>(obj: T) {
    window.dataLayer.push(obj);
  };

  if (locale.value !== EnumLocale.ZH_CN) {
    router.afterEach(() => {
      window.gtag('js', new Date());
      window.gtag('config', 'AW-10991029301');
    });
  }
});
